// Yofis — корпоративный мессенджер on-premise. Контракт API `yofis.v1`.
//
// Общие типы: пагинация, ключи, платформы, пользователь, присутствие, устройство, push.
// Источник истины по семантике — Документация/12-контракт-API.md (§3), версия 0.7.
// Правила контракта: только аддитивные изменения; идентификаторы — строки (ADR-024);
// время — google.protobuf.Timestamp в UTC; длительности медиа — поля `_ms` (int32).

// @generated by protoc-gen-es v2.15.0 with parameter "target=ts,import_extension=ts"
// @generated from file yofis/v1/common.proto (package yofis.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file yofis/v1/common.proto.
 */
export const file_yofis_v1_common: GenFile = /*@__PURE__*/
  fileDesc("ChV5b2Zpcy92MS9jb21tb24ucHJvdG8SCHlvZmlzLnYxIjEKCFBhZ2VJbmZvEhMKC25leHRfY3Vyc29yGAEgASgJEhAKCGhhc19tb3JlGAIgASgIIkMKCVB1YmxpY0tleRIpCglhbGdvcml0aG0YASABKA4yFi55b2Zpcy52MS5LZXlBbGdvcml0aG0SCwoDa2V5GAIgASgMIrECCgRVc2VyEg8KB2FkZHJlc3MYASABKAkSFAoMZGlzcGxheV9uYW1lGAIgASgJEhYKDmF2YXRhcl9maWxlX2lkGAMgASgJEhMKC3N0YXR1c190ZXh0GAQgASgJEiAKBGtpbmQYBSABKA4yEi55b2Zpcy52MS5Vc2VyS2luZBITCgtkZWFjdGl2YXRlZBgGIAEoCBIuCgpjcmVhdGVkX2F0GAcgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIkCghwcmVzZW5jZRgIIAEoCzISLnlvZmlzLnYxLlByZXNlbmNlEg0KBXRpdGxlGAkgASgJEhIKCmRlcGFydG1lbnQYCiABKAkSJQoJbm9kZV9yb2xlGAsgASgOMhIueW9maXMudjEuTm9kZVJvbGUiYQoIUHJlc2VuY2USJgoFc3RhdGUYASABKA4yFy55b2Zpcy52MS5QcmVzZW5jZVN0YXRlEi0KCWxhc3Rfc2VlbhgCIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAigAIKBkRldmljZRIKCgJpZBgBIAEoCRIMCgRuYW1lGAIgASgJEiQKCHBsYXRmb3JtGAMgASgOMhIueW9maXMudjEuUGxhdGZvcm0SEwoLYXBwX3ZlcnNpb24YBCABKAkSLgoKY3JlYXRlZF9hdBgFIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLQoJbGFzdF9zZWVuGAYgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIPCgdjdXJyZW50GAcgASgIEjEKEXNpZ25pbmdfYWxnb3JpdGhtGAggASgOMhYueW9maXMudjEuS2V5QWxnb3JpdGhtIrEBChJEZXZpY2VSZWdpc3RyYXRpb24SDAoEbmFtZRgBIAEoCRIkCghwbGF0Zm9ybRgCIAEoDjISLnlvZmlzLnYxLlBsYXRmb3JtEhMKC2FwcF92ZXJzaW9uGAMgASgJEigKC3NpZ25pbmdfa2V5GAQgASgLMhMueW9maXMudjEuUHVibGljS2V5EigKBHB1c2gYBSABKAsyGi55b2Zpcy52MS5QdXNoUmVnaXN0cmF0aW9uIl8KEFB1c2hSZWdpc3RyYXRpb24SKAoIcHJvdmlkZXIYASABKA4yFi55b2Zpcy52MS5QdXNoUHJvdmlkZXISDQoFdG9rZW4YAiABKAkSEgoKdm9pcF90b2tlbhgDIAEoCSpmCgxLZXlBbGdvcml0aG0SHQoZS0VZX0FMR09SSVRITV9VTlNQRUNJRklFRBAAEhkKFUtFWV9BTEdPUklUSE1fRUQyNTUxORABEhwKGEtFWV9BTEdPUklUSE1fRUNEU0FfUDI1NhACKrQBCghQbGF0Zm9ybRIYChRQTEFURk9STV9VTlNQRUNJRklFRBAAEhAKDFBMQVRGT1JNX1dFQhABEhwKGFBMQVRGT1JNX0RFU0tUT1BfV0lORE9XUxACEhoKFlBMQVRGT1JNX0RFU0tUT1BfTUFDT1MQAxIaChZQTEFURk9STV9ERVNLVE9QX0xJTlVYEAQSFAoQUExBVEZPUk1fQU5EUk9JRBAFEhAKDFBMQVRGT1JNX0lPUxAGKmkKDkVuY3J5cHRpb25Nb2RlEh8KG0VOQ1JZUFRJT05fTU9ERV9VTlNQRUNJRklFRBAAEhoKFkVOQ1JZUFRJT05fTU9ERV9TRVJWRVIQARIaChZFTkNSWVBUSU9OX01PREVfQ0xJRU5UEAIqZQoITm9kZVJvbGUSGQoVTk9ERV9ST0xFX1VOU1BFQ0lGSUVEEAASEwoPTk9ERV9ST0xFX09XTkVSEAESEwoPTk9ERV9ST0xFX0FETUlOEAISFAoQTk9ERV9ST0xFX01FTUJFUhADKmYKCFVzZXJLaW5kEhkKFVVTRVJfS0lORF9VTlNQRUNJRklFRBAAEhQKEFVTRVJfS0lORF9NRU1CRVIQARITCg9VU0VSX0tJTkRfR1VFU1QQAhIUChBVU0VSX0tJTkRfU1lTVEVNEAMqmgEKDVByZXNlbmNlU3RhdGUSHgoaUFJFU0VOQ0VfU1RBVEVfVU5TUEVDSUZJRUQQABIZChVQUkVTRU5DRV9TVEFURV9PTkxJTkUQARIXChNQUkVTRU5DRV9TVEFURV9BV0FZEAISGgoWUFJFU0VOQ0VfU1RBVEVfT0ZGTElORRADEhkKFVBSRVNFTkNFX1NUQVRFX0hJRERFThAEKncKDFB1c2hQcm92aWRlchIdChlQVVNIX1BST1ZJREVSX1VOU1BFQ0lGSUVEEAASFgoSUFVTSF9QUk9WSURFUl9BUE5TEAESFQoRUFVTSF9QUk9WSURFUl9GQ00QAhIZChVQVVNIX1BST1ZJREVSX1JVU1RPUkUQA0JFChFydS55b2Zpcy5wcm90by52MVABWiZ5b2Zpcy5ydS95b2Zpcy9nZW4vZ28veW9maXMvdjE7eW9maXN2MboCBVlvZmlzYgZwcm90bzM", [file_google_protobuf_timestamp]);

/**
 * Сведения о странице для курсорной пагинации (§1.6): `cursor` + `limit` в запросе
 * (по умолчанию 50, максимум 200) → `PageInfo` в ответе.
 *
 * @generated from message yofis.v1.PageInfo
 */
export type PageInfo = Message<"yofis.v1.PageInfo"> & {
  /**
   * Непрозрачный курсор для следующей страницы; пустой, если `has_more == false`.
   *
   * @generated from field: string next_cursor = 1;
   */
  nextCursor: string;

  /**
   * Есть ли ещё данные после этой страницы.
   *
   * @generated from field: bool has_more = 2;
   */
  hasMore: boolean;
};

/**
 * Describes the message yofis.v1.PageInfo.
 * Use `create(PageInfoSchema)` to create a new message.
 */
export const PageInfoSchema: GenMessage<PageInfo> = /*@__PURE__*/
  messageDesc(file_yofis_v1_common, 0);

/**
 * Публичный ключ устройства или сервера (ADR-005).
 *
 * @generated from message yofis.v1.PublicKey
 */
export type PublicKey = Message<"yofis.v1.PublicKey"> & {
  /**
   * Алгоритм подписи.
   *
   * @generated from field: yofis.v1.KeyAlgorithm algorithm = 1;
   */
  algorithm: KeyAlgorithm;

  /**
   * Сырые байты публичного ключа: Ed25519 — 32 байта; ECDSA P-256 — несжатая точка SEC1 (65 байт).
   *
   * @generated from field: bytes key = 2;
   */
  key: Uint8Array;
};

/**
 * Describes the message yofis.v1.PublicKey.
 * Use `create(PublicKeySchema)` to create a new message.
 */
export const PublicKeySchema: GenMessage<PublicKey> = /*@__PURE__*/
  messageDesc(file_yofis_v1_common, 1);

/**
 * Пользователь узла (сотрудник, гость или системный).
 *
 * @generated from message yofis.v1.User
 */
export type User = Message<"yofis.v1.User"> & {
  /**
   * Адрес: `localpart@domain` для сотрудника, `guest:<snowflake>@domain` для гостя, `system@domain` для узла
   * (ADR-004, ADR-024). Localpart сотрудника: `[a-z0-9._-]{3,32}`, начинается с буквы; `system` зарезервирован
   * за узлом — регистрация с ним запрещена, клиент показывает такого отправителя как «Система» (0.5).
   *
   * @generated from field: string address = 1;
   */
  address: string;

  /**
   * Отображаемое имя.
   *
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * Идентификатор файла аватара (`<snowflake>@<domain>`); пусто — аватара нет.
   *
   * @generated from field: string avatar_file_id = 3;
   */
  avatarFileId: string;

  /**
   * Текстовый статус («в отпуске до 5-го»).
   *
   * @generated from field: string status_text = 4;
   */
  statusText: string;

  /**
   * Вид пользователя.
   *
   * @generated from field: yofis.v1.UserKind kind = 5;
   */
  kind: UserKind;

  /**
   * Деактивирован администратором: не может входить, показывается серым.
   *
   * @generated from field: bool deactivated = 6;
   */
  deactivated: boolean;

  /**
   * Когда создан.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp | undefined;

  /**
   * Присутствие; заполняется только в ответах, где уместно (список участников, поиск), иначе пусто.
   *
   * @generated from field: yofis.v1.Presence presence = 8;
   */
  presence?: Presence | undefined;

  /**
   * Должность (v1). Правит администратор (`AdminService.UpdateUserProfile`) или SSO/LDAP; сам пользователь — нет.
   *
   * @generated from field: string title = 9;
   */
  title: string;

  /**
   * Отдел / подразделение (v1). Правится так же, как `title`.
   *
   * @generated from field: string department = 10;
   */
  department: string;

  /**
   * Роль на узле (0.4): заполняется в `GetMe`, в `GetUsers`/`SearchUsers` для администраторов и во всех ответах `AdminService`;
   * в остальных ответах — UNSPECIFIED.
   *
   * @generated from field: yofis.v1.NodeRole node_role = 11;
   */
  nodeRole: NodeRole;
};

/**
 * Describes the message yofis.v1.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/
  messageDesc(file_yofis_v1_common, 2);

/**
 * Присутствие пользователя.
 *
 * @generated from message yofis.v1.Presence
 */
export type Presence = Message<"yofis.v1.Presence"> & {
  /**
   * Состояние.
   *
   * @generated from field: yofis.v1.PresenceState state = 1;
   */
  state: PresenceState;

  /**
   * Когда пользователь был в сети последний раз (для OFFLINE/AWAY); политика видимости — на сервере.
   *
   * @generated from field: google.protobuf.Timestamp last_seen = 2;
   */
  lastSeen?: Timestamp | undefined;
};

/**
 * Describes the message yofis.v1.Presence.
 * Use `create(PresenceSchema)` to create a new message.
 */
export const PresenceSchema: GenMessage<Presence> = /*@__PURE__*/
  messageDesc(file_yofis_v1_common, 3);

/**
 * Зарегистрированное устройство пользователя (ADR-005).
 *
 * @generated from message yofis.v1.Device
 */
export type Device = Message<"yofis.v1.Device"> & {
  /**
   * Идентификатор устройства — Snowflake узла, десятичная строка (ADR-024).
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Имя устройства («iPhone Ивана», «Рабочий ноутбук»).
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * Платформа.
   *
   * @generated from field: yofis.v1.Platform platform = 3;
   */
  platform: Platform;

  /**
   * Версия приложения на устройстве.
   *
   * @generated from field: string app_version = 4;
   */
  appVersion: string;

  /**
   * Когда зарегистрировано.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp | undefined;

  /**
   * Последняя активность.
   *
   * @generated from field: google.protobuf.Timestamp last_seen = 6;
   */
  lastSeen?: Timestamp | undefined;

  /**
   * Это устройство, с которого сделан текущий запрос.
   *
   * @generated from field: bool current = 7;
   */
  current: boolean;

  /**
   * Каким алгоритмом устройство подписывает запросы (0.13). Сервер его и так знает — он им проверяет.
   * Смысл поля в том, что понижение на запасной P-256 должно быть видно не только тому, с кем оно
   * случилось: сотрудник со старой сборкой иначе не виден никому.
   *
   * @generated from field: yofis.v1.KeyAlgorithm signing_algorithm = 8;
   */
  signingAlgorithm: KeyAlgorithm;
};

/**
 * Describes the message yofis.v1.Device.
 * Use `create(DeviceSchema)` to create a new message.
 */
export const DeviceSchema: GenMessage<Device> = /*@__PURE__*/
  messageDesc(file_yofis_v1_common, 4);

/**
 * Данные для регистрации устройства при входе (`AuthService.LoginWithPassword` и др.).
 * Повторный вход с тем же публичным ключом переиспользует `device_id`.
 *
 * @generated from message yofis.v1.DeviceRegistration
 */
export type DeviceRegistration = Message<"yofis.v1.DeviceRegistration"> & {
  /**
   * Имя устройства.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Платформа.
   *
   * @generated from field: yofis.v1.Platform platform = 2;
   */
  platform: Platform;

  /**
   * Версия приложения.
   *
   * @generated from field: string app_version = 3;
   */
  appVersion: string;

  /**
   * Публичный ключ подписи запросов; приватный ключ живёт в защищённом хранилище устройства и сервер его не видит.
   *
   * @generated from field: yofis.v1.PublicKey signing_key = 4;
   */
  signingKey?: PublicKey | undefined;

  /**
   * Регистрация push-уведомлений; опционально, можно добавить позже через `UserService.UpdatePushRegistration`.
   *
   * @generated from field: yofis.v1.PushRegistration push = 5;
   */
  push?: PushRegistration | undefined;
};

/**
 * Describes the message yofis.v1.DeviceRegistration.
 * Use `create(DeviceRegistrationSchema)` to create a new message.
 */
export const DeviceRegistrationSchema: GenMessage<DeviceRegistration> = /*@__PURE__*/
  messageDesc(file_yofis_v1_common, 5);

/**
 * Регистрация устройства в push-провайдере (ADR-012: push без содержимого через шлюз).
 *
 * @generated from message yofis.v1.PushRegistration
 */
export type PushRegistration = Message<"yofis.v1.PushRegistration"> & {
  /**
   * Провайдер.
   *
   * @generated from field: yofis.v1.PushProvider provider = 1;
   */
  provider: PushProvider;

  /**
   * Токен устройства у провайдера.
   *
   * @generated from field: string token = 2;
   */
  token: string;

  /**
   * Токен PushKit VoIP — **только для APNs** (0.19). Входящий звонок обычным пушем на iOS не
   * показать: система придерживает фоновые уведомления, и телефон просто не зазвонит. На Android
   * второго токена нет — звонок будит приложение тем же токеном через FCM с высоким приоритетом,
   * поэтому поле необязательное. Асимметрия намеренная: общий список «токенов по видам»
   * смоделировал бы симметрию, которой не существует.
   *
   * @generated from field: string voip_token = 3;
   */
  voipToken: string;
};

/**
 * Describes the message yofis.v1.PushRegistration.
 * Use `create(PushRegistrationSchema)` to create a new message.
 */
export const PushRegistrationSchema: GenMessage<PushRegistration> = /*@__PURE__*/
  messageDesc(file_yofis_v1_common, 6);

/**
 * Алгоритмы подписи запросов (§2): Ed25519 предпочтителен, ECDSA P-256 — запасной для WebCrypto.
 *
 * @generated from enum yofis.v1.KeyAlgorithm
 */
export enum KeyAlgorithm {
  /**
   * Не задан.
   *
   * @generated from enum value: KEY_ALGORITHM_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Ed25519 (предпочтительно).
   *
   * @generated from enum value: KEY_ALGORITHM_ED25519 = 1;
   */
  ED25519 = 1,

  /**
   * ECDSA на кривой P-256 (fallback для браузеров без Ed25519 в WebCrypto).
   *
   * @generated from enum value: KEY_ALGORITHM_ECDSA_P256 = 2;
   */
  ECDSA_P256 = 2,
}

/**
 * Describes the enum yofis.v1.KeyAlgorithm.
 */
export const KeyAlgorithmSchema: GenEnum<KeyAlgorithm> = /*@__PURE__*/
  enumDesc(file_yofis_v1_common, 0);

/**
 * Платформа клиента (устройства).
 *
 * @generated from enum yofis.v1.Platform
 */
export enum Platform {
  /**
   * Не задана.
   *
   * @generated from enum value: PLATFORM_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Веб-клиент в браузере.
   *
   * @generated from enum value: PLATFORM_WEB = 1;
   */
  WEB = 1,

  /**
   * Десктоп, Windows.
   *
   * @generated from enum value: PLATFORM_DESKTOP_WINDOWS = 2;
   */
  DESKTOP_WINDOWS = 2,

  /**
   * Десктоп, macOS.
   *
   * @generated from enum value: PLATFORM_DESKTOP_MACOS = 3;
   */
  DESKTOP_MACOS = 3,

  /**
   * Десктоп, Linux.
   *
   * @generated from enum value: PLATFORM_DESKTOP_LINUX = 4;
   */
  DESKTOP_LINUX = 4,

  /**
   * Android.
   *
   * @generated from enum value: PLATFORM_ANDROID = 5;
   */
  ANDROID = 5,

  /**
   * iOS.
   *
   * @generated from enum value: PLATFORM_IOS = 6;
   */
  IOS = 6,
}

/**
 * Describes the enum yofis.v1.Platform.
 */
export const PlatformSchema: GenEnum<Platform> = /*@__PURE__*/
  enumDesc(file_yofis_v1_common, 1);

/**
 * Режим шифрования чата/сообщения (ADR-006, ADR-019).
 *
 * @generated from enum yofis.v1.EncryptionMode
 */
export enum EncryptionMode {
  /**
   * Не задан.
   *
   * @generated from enum value: ENCRYPTION_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Серверное шифрование: ключ чата у серверов-участников, клиент ключей не видит (v1).
   *
   * @generated from enum value: ENCRYPTION_MODE_SERVER = 1;
   */
  SERVER = 1,

  /**
   * Клиентское (E2EE) — закладка секретных чатов (ADR-019, v2+); в v1 сервер отвечает CAPABILITY_DISABLED.
   *
   * @generated from enum value: ENCRYPTION_MODE_CLIENT = 2;
   */
  CLIENT = 2,
}

/**
 * Describes the enum yofis.v1.EncryptionMode.
 */
export const EncryptionModeSchema: GenEnum<EncryptionMode> = /*@__PURE__*/
  enumDesc(file_yofis_v1_common, 2);

/**
 * Роль пользователя на узле (не путать с `MemberRole` — ролью в чате).
 *
 * @generated from enum yofis.v1.NodeRole
 */
export enum NodeRole {
  /**
   * Не задана (в ответах, где роль не раскрывается).
   *
   * @generated from enum value: NODE_ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Владелец узла: всё, включая передачу владения и удаление провайдеров входа.
   *
   * @generated from enum value: NODE_ROLE_OWNER = 1;
   */
  OWNER = 1,

  /**
   * Администратор узла: пользователи, настройки, аудит.
   *
   * @generated from enum value: NODE_ROLE_ADMIN = 2;
   */
  ADMIN = 2,

  /**
   * Обычный сотрудник.
   *
   * @generated from enum value: NODE_ROLE_MEMBER = 3;
   */
  MEMBER = 3,
}

/**
 * Describes the enum yofis.v1.NodeRole.
 */
export const NodeRoleSchema: GenEnum<NodeRole> = /*@__PURE__*/
  enumDesc(file_yofis_v1_common, 3);

/**
 * Вид пользователя.
 *
 * @generated from enum yofis.v1.UserKind
 */
export enum UserKind {
  /**
   * Не задан.
   *
   * @generated from enum value: USER_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Сотрудник компании (аккаунт узла).
   *
   * @generated from enum value: USER_KIND_MEMBER = 1;
   */
  MEMBER = 1,

  /**
   * Эфемерный гость по ссылке-праву (ADR-004, ADR-007); живёт, пока живо право.
   *
   * @generated from enum value: USER_KIND_GUEST = 2;
   */
  GUEST = 2,

  /**
   * Системный отправитель (сообщения узла, боты узла).
   *
   * @generated from enum value: USER_KIND_SYSTEM = 3;
   */
  SYSTEM = 3,
}

/**
 * Describes the enum yofis.v1.UserKind.
 */
export const UserKindSchema: GenEnum<UserKind> = /*@__PURE__*/
  enumDesc(file_yofis_v1_common, 4);

/**
 * Состояние присутствия.
 *
 * @generated from enum yofis.v1.PresenceState
 */
export enum PresenceState {
  /**
   * Не задано.
   *
   * @generated from enum value: PRESENCE_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * В сети (открыт стрим событий).
   *
   * @generated from enum value: PRESENCE_STATE_ONLINE = 1;
   */
  ONLINE = 1,

  /**
   * Отошёл: клиент сообщил о неактивности.
   *
   * @generated from enum value: PRESENCE_STATE_AWAY = 2;
   */
  AWAY = 2,

  /**
   * Не в сети: ставит сервер по разрыву стрима.
   *
   * @generated from enum value: PRESENCE_STATE_OFFLINE = 3;
   */
  OFFLINE = 3,

  /**
   * Скрыт: пользователь не показывает присутствие другим.
   *
   * @generated from enum value: PRESENCE_STATE_HIDDEN = 4;
   */
  HIDDEN = 4,
}

/**
 * Describes the enum yofis.v1.PresenceState.
 */
export const PresenceStateSchema: GenEnum<PresenceState> = /*@__PURE__*/
  enumDesc(file_yofis_v1_common, 5);

/**
 * Провайдер push-уведомлений.
 *
 * @generated from enum yofis.v1.PushProvider
 */
export enum PushProvider {
  /**
   * Не задан.
   *
   * @generated from enum value: PUSH_PROVIDER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Apple Push Notification service.
   *
   * @generated from enum value: PUSH_PROVIDER_APNS = 1;
   */
  APNS = 1,

  /**
   * Firebase Cloud Messaging.
   *
   * @generated from enum value: PUSH_PROVIDER_FCM = 2;
   */
  FCM = 2,

  /**
   * RuStore Push.
   *
   * @generated from enum value: PUSH_PROVIDER_RUSTORE = 3;
   */
  RUSTORE = 3,
}

/**
 * Describes the enum yofis.v1.PushProvider.
 */
export const PushProviderSchema: GenEnum<PushProvider> = /*@__PURE__*/
  enumDesc(file_yofis_v1_common, 6);

